/**
 * One thread per new chat (Codex review of FE #2325). The first message and the first dropped file
 * both need the new chat's thread: whichever asks first creates it and the other waits for the same
 * one, so a file and a message sent together never land in two chats.
 *
 * `seq` is the provider's open-chat counter (`openSeqRef`): New chat and opening another chat bump it.
 * A thread created for an earlier chat resolves `null`, so it never replaces the chat now on screen.
 * A failed create isn't kept: the next attempt for the same chat tries again.
 */
export function threadStarter(currentSeq) {
  let pending = null; // { seq, promise } for the chat that asked last
  return async (seq, create) => {
    if (!pending || pending.seq !== seq) {
      const promise = create();
      pending = {
        seq,
        promise
      };
      promise.catch(() => {
        if (pending?.promise === promise) pending = null;
      });
    }
    const created = await pending.promise;
    return seq === currentSeq() ? created : null;
  };
}